// Re-export from new location
import AddAppointmentDialog from './add-appointment/AddAppointmentDialog'
export default AddAppointmentDialog
